/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
Coded by www.creative-tim.com
=========================================================
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar"; // <-- Import the Snackbar

// Firebase
import { getAuth, updateProfile } from "firebase/auth";

// Layout
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Image
import bgImage from "assets/images/bg-sign-up-cover.jpeg";

function Cover() {
  const [nombre, setNombre] = useState("");

  // States for snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarColor, setSnackbarColor] = useState("success"); // or "error"

  const handleCloseSnackbar = () => setSnackbarOpen(false);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const auth = getAuth();
      if (!auth.currentUser) {
        throw new Error("No hay un usuario autenticado para actualizar.");
      }

      await updateProfile(auth.currentUser, {
        displayName: nombre,
      });

      // Éxito: mostrar snackbar en verde
      setSnackbarMessage("¡Nombre actualizado correctamente!");
      setSnackbarColor("success");
      setSnackbarOpen(true);
    } catch (error) {
      // Error: mostrar snackbar en rojo
      setSnackbarMessage(`Error al actualizar: ${error.message}`);
      setSnackbarColor("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Actualiza tu nombre
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Ingresa el nuevo nombre y haz clic en &quot;Guardar&quot;
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSave}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Nombre"
                variant="standard"
                fullWidth
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                Guardar
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>

      {/* Snackbar (notificación) */}
      <MDSnackbar
        color={snackbarColor}
        icon={snackbarColor === "success" ? "check" : "warning"}
        title={snackbarColor === "success" ? "Éxito" : "Error"}
        content={snackbarMessage}
        dateTime=""
        open={snackbarOpen}
        onClose={handleCloseSnackbar}
        close={handleCloseSnackbar}
        bgWhite
      />
    </CoverLayout>
  );
}

export default Cover;
